var exports = {
  "az": "Box__z1D6Yj",
  "wy": "Box_1__xhRTd1",
  "m4": "Octicon__LnKEda",
  "QH": "Octicon_1__ECep2N",
  "pv": "Box_2__t180V0",
  "w9": "Box_3__if70sK",
  "JK": "Octicon_2__Y2frIH",
  "pQ": "Box_4__AAoE5F",
  "$n": "Button__yiRuM3",
  "ws": "Box_5__eqeJN_",
  "D6": "Box_6__AWig02",
};

module.exports = exports;
